import BlogPage from "pages/BlogPage/BlogPage";
import CVPage from "pages/CVPage/CVPage";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import HomePage from "pages/HomePage/HomePage";
import NotFoundPage from "pages/NotFoundPage/NotFoundPage";
import React from "react";
import { Route, Switch } from "react-router-dom";
import "./Layout.style.css";
import { MainContainer } from "./MainContainer";

export const Layout = () => {
  return (
    <MainContainer>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/cv" exact component={CVPage} />
        <Route path="/blog" exact component={BlogPage} />
        <Route path="/error" exact component={ErrorPage} />
        <Route exact component={NotFoundPage} />
      </Switch>
    </MainContainer>
  );
};
